export default {
  "formValidationError.numbersOnly": "Input can only consit of numbers",
};
